// extracted by mini-css-extract-plugin
export var caption = "NewProductCard-module--caption--c024e";
export var landscape = "NewProductCard-module--landscape--b9968";
export var root = "NewProductCard-module--root--16cbe";